export const SET_ATTORNEYS = "SET_ATTORNEYS";

export const setAttorneysData = (user) => {
  return {
    type: SET_ATTORNEYS,
    payload: user,
  };
};
